<template>
  <section
    :class="{
      'section-builder-card-two-column': true,
    }"
  >
    <GeneralTheme
      :theme="configuration"
      :class="{
        'bg overflow-background bg-left pb-72 pt-10 lg:bg-center lg:pb-32 lg:pt-40': true,
      }"
    >
      <CardTwoColumnContentCard
        v-if="cardTwoColumns"
        v-bind="cardTwoColumns"
      />
    </GeneralTheme>
  </section>
</template>

<script lang="ts" setup>
import CardTwoColumnContentCard from './CardTwoColumnContentCard.vue';
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import type { SectionBuilderCardTwoColumns } from '~/sanity/types';
const props = defineProps<SectionBuilderCardTwoColumns>();
provide('useDarkTheme', props.useDarkTheme);
</script>

<style lang="scss">
.product-page .section-builder-card-two-column .bg {
  padding-top: 200px !important;
  padding-bottom: 128px !important;
  @media screen and (min-width: 768px) {
    padding-top: 320px !important;
  }
}
.section-builder-card-two-column h4 {
  line-height: 28px !important;
}
.section-builder-card-two-column p:first-of-type {
  margin-bottom: 15px !important;
  padding-right: 40px;
}
.section-builder-card-two-column p:not(:first-of-type) {
  margin-top: 47px !important;
  padding-right: 40px;
}

@media (max-width: 768px) {
  .section-builder-card-two-column p:first-of-type {
    font-size: 12px !important;
    line-height: 14px !important;
    padding-right: 0;
  }
  .section-builder-card-two-column p:not(:first-of-type) {
    padding-right: 0;
  }
  .section-builder-card-two-column h4 {
    font-size: 16px !important;
    line-height: 19px !important;
  }
  .product-page .section-builder-card-two-column .bg {
    background-position: center !important;
  }
}
</style>
